import { useEffect, useState } from "react";

export function useIsMobile(
  breakPoint: number = 768,
  initialValue?: boolean | null
) {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [isMobile, setIsMobile] = useState(
    typeof initialValue !== "undefined" ? initialValue : false
  );

  useEffect(() => {
    // only execute all the code below in client side
    if (typeof window !== "undefined") {
      const handleResize = () => {
        const isMobile = window.innerWidth < breakPoint;
        setIsMobile((prev) => (prev !== isMobile ? isMobile : prev));
      };

      window.addEventListener("resize", handleResize);

      handleResize();

      return () => window.removeEventListener("resize", handleResize);
    }
  }, [breakPoint]);

  return isMobile;
}
